export default __webpack_public_path__ + "static/media/comfydes.06b09f87.png";